<template>

  <div :class="box_class">
    <div class="" style="position:initial;text-align: center;height: 100%">
      <div class="col-12">
        <img class="box-icon" :src="image"/>
      </div>
      <div class="col-12 box-name" style="text-align: center">
            <span  style="">
              {{title}}
            </span>
      </div>
    </div>
  </div>

</template>


<script>

  import {bus} from '../main.js'

  export default {
    name: 'TheContainer',
    props: {
      box_class: String,
      color: String,
      title: String,
      image: String,
    },
    components: {},
    data() {
      return {}
    },
    mounted() {

    },
    methods: {}
  }
</script>
<style>

    :root {
      --red: rgb(244, 67, 54);
      --grey: rgb(158, 158, 158);
      --light_blue: #16b9f4;
      --orange: rgb(255, 87, 34);
      --light_orange: #F0A30A;
      --teal: rgb(0, 150, 136);
      --purple: #AA00FF;
      --dark_purple: #765f89;
      --blue: rgb(68, 114, 196);
      --green: #23dd26;
      --blue_grey: rgb(96, 125, 139);
      --dark_green: #6D8764;
      --brown: #835a2c;
      --light_brown: #a0522c;
      --crimson: #A20025;

    }
    .messenger .box-name{
      /*position: relative;*/
      bottom: 171px;
    }
  .main-box{
    margin: 8px;
    height: 87%;
    aspect-ratio: 1;
  }
  .main-box-large{
    margin: 8px;
     height: 93%;
    /*aspect-ratio: 1;*/
  }
  .main-box-rect{
    margin: 8px;
    height: 87%;

    /* height: 270px; */
    /*aspect-ratio: 2/1;*/
  }
  .main-box-rect-rev{
    margin: 8px;
    /*width: 87%;*/

    /* height: 270px; */
    aspect-ratio: 491/1000;
  }
    .group-box{
      margin: 8px;
      height: 87%;
      aspect-ratio: 1;
  }
    .invert-white img{
      filter: brightness(0) invert(1);
    }
  .box-name{
    /*height: 40px;*/
    bottom: 10px;
    font-size: 13px;
    position: initial;
  }
  .summary_box .box-name{
    height: unset;
  }
  .box-icon {
     width: 60%;
    height: auto;
    padding-top: 20px;
    /* padding: 10px; */
    /*height: 65px;*/
    aspect-ratio: 1/1;
  }
    .group-box img{
      width: 57%;
      /*padding: 8px;*/
      /*height: 129px;*/
    }
    .group-box .box-name{
      /*width: 57%;*/
      /*padding: 8px;*/
      /*height: 129px;*/
      bottom: 34px;
      position: initial;
    }
  .large-box-icon img {
    width: 55%;
    padding-top: 70px;
    height: auto;
  }
    .main-box-rect img {
      width: auto;
      padding-top: 18px;
      width: 27%;
  }
  .messenger img {
    width: 59%;
    margin-top: 52%;
    padding-top: 0;
  }
  .metaverse img {
    width: unset;
    max-width: 100%;
    padding-top: 0px;
    height: unset;
    aspect-ratio: 1.3/1;
  }
  .box-no-icon img {
    display: none;
  }

  .tamirat {
    background-color: var(--red);
    color: white;
  }

  .network {
    background-color: var(--dark_green);
    color: white;
  }

  .software {
    background-color: var(--teal);
    color: white;
  }

  .jobs {
    background-color: var(--light_orange);
    color: white;
  }
  .messenger{
    background:url("/main_icons/messenger.svg");
    color: white;
    background-size: cover;
  }
  .golden-card{
    background:url("/main_icons/golden_card_back.jpg");
    color: white;
    background-size: cover;
  }
  .design{
    background-color: var(--orange);
    color: white;
  }
  .ads{
    background-color: var(--dark_purple);
    color: white;
  }
  .metaverse{
    background-color: white;
    color: black;
  }
  .building{
    background-color: var(--light_blue);
    color: white;
  }
  .food{
    background-color: var(--green);
    color: white;
  }
  .company{
    background-color: var(--blue);
    color: white;
  }
  .shop{
    background-color: var(--dark_green);
    color: white;
  }
  .guarante{
    background-color: var(--crimson);
    color: white;
  }
  .summary_box{
    background-color: var(--blue_grey);
    color: white;
  }
  .blog{
    background-color: var(--purple);
    color: white;
  }
  .enamad{
    background-color: var(--brown);
    color: white;
  }
  .samandehi{
    background-color: var(--light_brown);
    color: white;
  }
    .enamad .box-icon ,.samandehi .box-icon {
      width: 64%;
    }
    @media (max-width: 480px) {
      .no-mt-mobile{
        margin-top: 0px;
      }
    }

</style>
